/**
 * @packageDocumentation
 * @module api.functional.invitations.resend
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { ServiceResponse__object } from "../../../structures/ServiceResponse__object";
import type { ServiceResponsenull } from "../../../structures/ServiceResponsenull";

/**
 * @controller InvitationController.resendInvitation
 * @path POST /invitations/:id/resend
 * @accessor api.functional.invitations.resend.resendInvitation
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function resendInvitation(
  connection: IConnection,
  id: string,
): Promise<resendInvitation.Output> {
  return PlainFetcher.fetch(connection, {
    ...resendInvitation.METADATA,
    template: resendInvitation.METADATA.path,
    path: resendInvitation.path(id),
  });
}
export namespace resendInvitation {
  export type Output = ServiceResponse__object | ServiceResponsenull;

  export const METADATA = {
    method: "POST",
    path: "/invitations/:id/resend",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (id: string) =>
    `/invitations/${encodeURIComponent(id?.toString() ?? "null")}/resend`;
}
